import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ENV } from "@app/constants/env";
import { getToken } from '@app/helpers/authProvider';
import { TrfcEmailTemplate } from '@feature/types/email.template.type';

const API_BASE_URL = ENV.BASE_API_URL +ENV.TEMPLATES_APIURL;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken();
    if (token) {
      let headers: Headers;
      if ((args as FetchArgs).headers instanceof Headers) {
        headers = (args as FetchArgs).headers as Headers;
      } else {
        headers = new Headers((args as FetchArgs).headers as HeadersInit);
      }

      headers.set('Authorization', `Bearer ${token}`);
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401 && token) {
      // refresh token flow could go here
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  error?: string;
}

export const trfcEmailTemplateSliceApi = createApi({
  reducerPath: 'trfcEmailTemplateSliceApi',
  baseQuery: authBaseQuery,
  tagTypes: ['emailtemplate'],
  endpoints: (builder) => ({
    getTrfcEmailTemplateByShow: builder.query<ApiResponse<TrfcEmailTemplate[]>, { ShowId: number }>({
      query: ({ ShowId }) => ({
        url: `EmoTemplate/GetTrfcEmailTemplateByShow/${ShowId}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      providesTags: ['emailtemplate'],
    }),
    updateTrfcEmailTemplate: builder.mutation<ApiResponse<TrfcEmailTemplate>, TrfcEmailTemplate>({
      query: (emailTemplate) => ({
        url: 'EmoTemplate/UpdateTrfcEmailTemplate',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: emailTemplate,
      }),
      invalidatesTags: ['emailtemplate'],
    }),
  }),
});

export const {
  useGetTrfcEmailTemplateByShowQuery,
  useUpdateTrfcEmailTemplateMutation,
} = trfcEmailTemplateSliceApi;
